import { render, staticRenderFns } from "./classPri.vue?vue&type=template&id=3ea2ea9f&scoped=true&"
import script from "./classPri.vue?vue&type=script&lang=js&"
export * from "./classPri.vue?vue&type=script&lang=js&"
import style0 from "./classPri.vue?vue&type=style&index=0&id=3ea2ea9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea2ea9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
